module.exports = __webpack_public_path__ + "position-aacabfbb.svg";